import { DonutChart, IDonutChartProps } from '@fluentui/react-charting';
import { FC } from 'react';
import styled from 'styled-components';
import { AppThemed } from '../../styles/themes';
import { nameof } from '../../utils/stringUtils';

function getFontSize(text: string): string {
    if (text.length > 8)
        return '0.9rem';

    if (text.length > 6)
        return '1rem';

    if (text.length > 3)
        return '1.2rem';

    return '1.4rem';
}

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  user-select: none;
`;

const Chart = styled(DonutChart)`
  padding-top: 2px;
  display: flex;
  justify-content: center;
  align-items: center;

  & div {
    display: flex;
  }

  svg path {
    stroke: ${p => p.theme.palette.white};
  }
`;

const Text = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  text-align: center;
  font-size: ${p => getFontSize(p.children as string)};
  font-weight: 500;
`;

interface IProps extends AppThemed<IDonutChartProps> {
    text: string;
}

const StyledDonutChart: FC<IProps> = ({ text, ...donutChartProps }) => (
    <Container>
        <Chart {...donutChartProps} />
        <Text aria-label="chart-value">{text}</Text>
    </Container>
);

StyledDonutChart.displayName = nameof({ StyledDonutChart });
export default StyledDonutChart;